import { render, staticRenderFns } from "./IbBlinkingAnimationSentences.vue?vue&type=template&id=204f4396"
import script from "./IbBlinkingAnimationSentences.vue?vue&type=script&lang=js"
export * from "./IbBlinkingAnimationSentences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports